import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage.jsx';
import FAQPage from './FAQPage.jsx';
import AboutUs from './AboutUs.jsx';
import FreeConsultForm from './FreeConsultForm.jsx';
import OurWorks from './OurWorks.jsx';
import InosinLabs from './InosinLabs.jsx';
import ServerHostingPage from './ServerHostingPage.jsx';
import WebsiteDevelopment from './WebsiteDevelopment.jsx';
import WebsiteRevamp from './WebsiteRevamp.jsx';
import Privacy from './PrivacyPage.jsx';
import Pricing from './Pricing.jsx';
import FoundationCommercialCleaning from './FoundationCommercialCleaning.jsx';



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/consult" element={<FreeConsultForm/>} />
        <Route path="/ourworks" element={<OurWorks/>} />
        <Route path="/ourworks/inosin-labs" element={<InosinLabs/>} />
        <Route path="/ourworks/foundation-commercial-cleaning" element={<FoundationCommercialCleaning/>} />
        <Route path="/hosting-maintenance" element={<ServerHostingPage/>} />
        <Route path="/web-development" element={<WebsiteDevelopment/>} />
        <Route path="/website-revamp" element={<WebsiteRevamp/>} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="/pricing" element={<Pricing/>} />
      </Routes>
    </Router>
  );
}

export default App;
